import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        if (cancelled) return;
        setUser(res.data.user);
        // Clear hash and go to admin if admin, else home
        const dest = res.data.user?.role === "admin" ? "/admin" : "/";
        window.history.replaceState({}, document.title, dest);
        navigate(dest, { replace: true, state: { user: res.data.user } });
      } catch (e) {
        navigate("/", { replace: true });
      }
    })();
    return () => { cancelled = true; };
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--bone)]">
      <div className="text-center">
        <div className="overline text-[var(--terracotta)]">Signing you in</div>
        <div className="font-serif text-3xl mt-4">One moment…</div>
      </div>
    </div>
  );
}
